import {BaseProps, CategoryProps, TreatmentProps} from './types';

export const getFormattedName = (items: BaseProps[]) => items
    .reduce((acc, item) => {
      return acc ? `${acc}/ ${item?.name}` : item?.name;
    }, '');

export const getTreatmentFormattedName = (items: TreatmentProps[]) => items
    .reduce((acc, item) => {
      return acc ? `${acc}/ ${item?.code} ${item?.name}` :
      `${item?.code} ${item?.name}`;
    }, '');

export const getCurrentEntityObject = (
    id: number,
    entityName: string,
    treatmentsData: CategoryProps[]
) => {
  for (const category of treatmentsData) {
    const {groupChains} = category;

    if (entityName === 'category' && category.id === id) {
      return {name: category.name};
    } else if (entityName === 'group') {
      for (const {groups} of groupChains) {
        for (const group of groups) {
          if (group.id === id) {
            return {name: group.name};
          }
        }
      }
    } else if (entityName === 'treatment') {
      for (const {treatments} of groupChains) {
        for (const treatmentArray of treatments) {
          for (const treatment of treatmentArray) {
            if (treatment.id === id) {
              return {code: treatment.code, name: treatment.name};
            }
          }
        }
      }
    }
  }
};
